import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { I18nProvider } from './i18n';
import { CookieConsentProvider } from './lib/cookieConsent';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import SeoManager from './components/SeoManager';
import Home from './pages/Home';
import Cardiometabolica from './pages/Cardiometabolica';
import SeniorSaludable from './pages/SeniorSaludable';
import Rehabilitacion from './pages/Rehabilitacion';
import MedicinaFamilia from './pages/MedicinaFamilia';
import SobreVidat from './pages/SobreVidat';
import ProgramarVisita from './pages/ProgramarVisita';
import Admin from './pages/Admin';
import Adiposidad from './pages/Adiposidad';
import Diabetes from './pages/Diabetes';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiesPolicy from './pages/CookiesPolicy';
import LegalNotice from './pages/LegalNotice';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const PublicLayout = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <CookieConsentProvider>
          <BrowserRouter>
            <ScrollToTop />
            <SeoManager />
            <Routes>
              <Route path="/admin" element={<Admin />} />
              <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
              <Route path="/valoracion-cardiometabolica" element={<PublicLayout><Cardiometabolica /></PublicLayout>} />
              <Route path="/valoracion-adiposidad-metabolismo" element={<PublicLayout><Adiposidad /></PublicLayout>} />
              <Route path="/valoracion-diabetes-tipo-2" element={<PublicLayout><Diabetes /></PublicLayout>} />
              <Route path="/senior-saludable" element={<PublicLayout><SeniorSaludable /></PublicLayout>} />
              <Route path="/rehabilitacion-funcional" element={<PublicLayout><Rehabilitacion /></PublicLayout>} />
              <Route path="/medicina-de-familia" element={<PublicLayout><MedicinaFamilia /></PublicLayout>} />
              <Route path="/sobre-vidat" element={<PublicLayout><SobreVidat /></PublicLayout>} />
              <Route path="/programar-visita" element={<PublicLayout><ProgramarVisita /></PublicLayout>} />
              <Route path="/politica-de-privacidad" element={<PublicLayout><PrivacyPolicy /></PublicLayout>} />
              <Route path="/politica-de-cookies" element={<PublicLayout><CookiesPolicy /></PublicLayout>} />
              <Route path="/aviso-legal" element={<PublicLayout><LegalNotice /></PublicLayout>} />
              <Route path="*" element={<PublicLayout><Home /></PublicLayout>} />
            </Routes>
            <CookieBanner />
          </BrowserRouter>
        </CookieConsentProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
